import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { ErrorMessage, Form, Formik } from "formik";
import { TextInput } from "shared/components/text-input/text-input";
import { FormulaireSubmit } from "./formulaire-submit";
import './formulaire_step3.scss';
import { Container, Typography, Box, Button, Tooltip, IconButton } from '@mui/material';
import {
  Resiliation,
  choixSchema,
  ChoixResiliation,
} from "modules/resiliation/model/resiliation";
import './formulaire.scss';
import ProgressBar from "shared/components/progress-bar/progress-bar";
import { SpbButtonSelect } from "shared/components/spb-button-select/spb-button-select";

import { FormulaireSubStep3 } from "./formulaire_subStep3";
import { isMobile } from "react-device-detect";

export interface IFormulaireStep3Props {
  resiliation: Resiliation;
  motif: string;
  submit: (resiliation: Resiliation) => void;
  cancel: () => void;
}


export const FormulaireStep3 = ({
  resiliation,
  motif,
  submit,
  cancel,
}: IFormulaireStep3Props) => {

  const infoIcone: string = require("../../../../assets/infoIcone.svg").default;

  const [selectedButton1, setSelectedButton1] = useState(false);
  const [selectedButton2, setSelectedButton2] = useState(false);
  const [subStep3, setSubStep3] = useState(false);

  const handleClickButton1 = () => {
    setSelectedButton1(!selectedButton1);
    setSelectedButton2(false);
  };

  const handleClickButton2 = () => {
    setSelectedButton2(!selectedButton2);
    setSelectedButton1(false);
  };

  const [isTooltipOpen, setTooltipOpen] = useState(false);

  const handleTooltipToggle = () => {
    setTooltipOpen(!isTooltipOpen);
  };



  return (
    <div>
      {
        subStep3 ?
          <FormulaireSubStep3
            resiliation={resiliation}
            cancel={cancel}
            submit={submit}
          />
          :
          <div className={isMobile ? 'content-mobile' : 'content'} >
            <div className="container-box">
              <div className="avatar">

              </div>
              <Formik
                initialValues={resiliation.choixResil}
                validationSchema={choixSchema}
                onSubmit={(values) => {
                  
                  submit({ ...resiliation, ...{ choixResil: { ...values } } });
                }}
              >
                {({ values, errors, touched, handleChange, setFieldTouched, setFieldValue }) => {
              


                  return (


                    <Form>
                      <Typography className="info-text" variant="body1">{motif}</Typography>

                      <Box className='choice-btn-box' mt={2} style={isMobile ? { flexDirection: "column" } : {}} >

                        <Button
                          name="choixResiliation"
                          className={
                            (touched.choixResiliation && values.choixResiliation === ChoixResiliation.ProchaineEcheance
                              ||
                              (values.choixResiliation === ChoixResiliation.ProchaineEcheance && resiliation.choixResil.choixResiliation === ChoixResiliation.ProchaineEcheance)
                            )
                              ? "choice-btn selected"
                              : "choice-btn"
                          }
                          variant="contained"
                          onClick={() => {
                            if (!touched.choixResiliation) {
                              setFieldTouched("choixResiliation", true);
                            }
                            if (values.choixResiliation === ChoixResiliation.ProchaineEcheance) {
                              setFieldValue("choixResiliation", null); // Réinitialiser la valeur de choixResiliation
                            } else {
                              setFieldValue("choixResiliation", ChoixResiliation.ProchaineEcheance);
                              setFieldTouched("choixResiliation", true);
                              // handleClickButton1();
                            }
                          }}
                        >
                          <span className="spanBox">
                            Résilier mon contrat à la prochaine échéance annuelle
                          </span>

                          <Tooltip
                            title="Veuillez vous reporter à votre notice d’assurance pour comprendre quelle est cette échéance"
                            arrow
                            open={isTooltipOpen}
                            onClick={handleTooltipToggle} // Gère le clic pour les appareils mobiles
                            onMouseEnter={handleTooltipToggle} // Gère le survol de la souris pour les ordinateurs de bureau
                            onMouseLeave={handleTooltipToggle} // Gère la sortie du survol de la souris pour les ordinateurs de bureau
                          >
                            <IconButton className='info-icon info-icon-btn' size="small">
                              {/* <InfoIcon /> */}
                              <img
                                // className={selectedButton1  ? 'info-icon-img icon-selected' : 'info-icon-img'}
                                className='info-icon-img'
                                src={infoIcone} alt="icone information"
                              />
                            </IconButton>
                          </Tooltip>
                        </Button>


                        <Button
                          name="choixResiliation"
                          className={
                            (touched.choixResiliation && values.choixResiliation === ChoixResiliation.Maintenant || (values.choixResiliation === ChoixResiliation.Maintenant && resiliation.choixResil.choixResiliation === ChoixResiliation.Maintenant))
                              ? "choice-btn selected"
                              : "choice-btn"
                          }
                          variant="contained"
                          onClick={() => {
                            if (!touched.choixResiliation) {
                              setFieldTouched("choixResiliation", true);
                            }
                            if (values.choixResiliation === ChoixResiliation.Maintenant) {
                              setFieldValue("choixResiliation", null); // Réinitialiser la valeur de choixResiliation
                            } else {
                              setFieldValue("choixResiliation", ChoixResiliation.Maintenant);
                              resiliation.choixResil.choixResiliation === ChoixResiliation.Maintenant;
                              setFieldTouched("choixResiliation", true);
                              // handleClickButton2();
                            }
                          }}
                        >
                          <span className="spanBox">Renoncer/résilier mon contrat maintenant</span>
                        </Button>

                      </Box>
                      {(errors.choixResiliation && !values.choixResiliation) && (
                        <span className='non-valid'>{errors.choixResiliation as string}</span>
                      )}
                      {/* <ErrorMessage
                        name="choixResiliation"
                        component="span"
                        className="non-valid"
                      /> */}

                      <FormulaireSubmit previous={() => cancel()} />
                    </Form>)

                }

                }

              </Formik>
            </div>
          </div>
      }
    </div >)
}


